import i18n from '@/lang/i18n'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.tc('configuration.sections.incidentTypes', 1),
            colId: 'nameTranslationKey',
            field: 'name',
            minWidth: 280,
            flex: 2,
            suppressSizeToFit: true
        },
        {
            type: 'text',
            headerName: i18n.tc('configuration.grid.description', 1),
            colId: 'descriptionTranslationKey',
            field: 'description',
            minWidth: 280,
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.system'),
            field: 'systemDefined',
            minWidth: 100,
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            field: 'active',
            minWidth: 100,
            flex: 1
        }
    ]
}
